// extracted by mini-css-extract-plugin
module.exports = {"mouse":"MouseAnimtaion_mouse__2Ohz1","dot":"MouseAnimtaion_dot__2HNAl"};